// @flow

import { useState, useEffect } from 'react';
import { useUserInputValidationError } from '@tectonics/prs/validation/use-user-input-validation-result';

const state: { [inputName: string]: boolean } = {};

export function useMustShow(inputName: string, defaultVisible: boolean = false): boolean {
  const [mustShow, setMustShow] = useState(state[inputName] ?? defaultVisible);
  const validationError = useUserInputValidationError(inputName);

  useEffect(() => {
    if (!mustShow && !!validationError) {
      state[inputName] = true;
      setMustShow(state[inputName]);
    }
  }, [validationError]);

  return mustShow;
}
